import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ItemSelectionViewModal from './itemSelectionView/ItemSelectionViewModal';
import './ItemsModal.css';

const ItemsModal = ({
  show,
  onHide,
  onItemSelect,
  onAccessorySelect,
  addItem,
  typeName,
  handleDoorsView,
  canvasHeight,
  title = "Items"
}) => {
  const { t } = useTranslation();
  const [showSubModal, setShowSubModal] = useState(false);
  const [selectedItemType, setSelectedItemType] = useState('');

  if (!show && !showSubModal) {
    return null;
  }

  const items = [
    // Windows
    {
      id: 'casement',
      name: t('itemSelection-casement', 'Casement'),
      thumbnail: '/thumbnails/Window_Casement_Double.png',
      eventKey: 'Casement',
      category: 'windows'
    },
    {
      id: 'sash',
      name: t('itemSelection-sash', 'Sash'),
      thumbnail: '/thumbnails/Window_Sash_Double.png',
      eventKey: 'Sash',
      category: 'windows'
    },
    {
      id: 'slider',
      name: t('itemSelection-slider', 'Slider'),
      thumbnail: '/thumbnails/Window_Slider_Single.png',
      eventKey: 'Slider',
      category: 'windows'
    },
    {
      id: 'contemporary',
      name: t('itemSelection-contemporary', 'Contemporary'),
      thumbnail: '/thumbnails/Window_Contemporary_ThirdLeftDivMiddle.png',
      eventKey: 'Contemporary',
      category: 'windows'
    },
    {
      id: 'fixed',
      name: t('itemSelection-fixed', 'Fixed'),
      thumbnail: '/thumbnails/Window_Fixed_HalfMoon.png',
      eventKey: 'Fixe',
      category: 'windows'
    },
    // Doors
    {
      id: 'singleDoor',
      name: t('itemSelection-singleDoor', 'Single Door'),
      thumbnail: '/thumbnails/Single_Embossed1AGlassAt1NoSidelight.png',
      eventKey: 'Single Door',
      category: 'doors'
    },
    {
      id: 'doubleDoor',
      name: t('itemSelection-doubleDoor', 'Double Door'),
      thumbnail: '/thumbnails/double_Embossed1AGlassAt1NoSidelight.png',
      eventKey: 'Double Door',
      category: 'doors'
    },
    {
      id: 'garageDoor',
      name: t('itemSelection-garageDoor', 'Garage Door'),
      thumbnail: '/thumbnails/GarageDoor_Classic_9x7.png',
      eventKey: 'Garage Door',
      category: 'doors'
    },
    // Accessories
    {
      id: 'accessories',
      name: t('itemSelection-accessories', 'Accessories'),
      thumbnail: '/thumbnails/shutter_standard_white.png',
      eventKey: 'Accessories',
      category: 'accessories'
    }
  ];

  const categories = [
    { id: 'windows', name: t('itemSelection-windows', 'Windows'), icon: '🪟' },
    { id: 'doors', name: t('itemSelection-doors', 'Doors'), icon: '🚪' },
    { id: 'accessories', name: t('itemSelection-accessories', 'Accessories'), icon: '🔧' }
  ];

  const handleItemClick = (item) => {
    // Use the same modal flow for windows, doors, garage doors, and accessories.
    setSelectedItemType(item.eventKey);
    setShowSubModal(true);
  };
  
  const handleSubModalHide = () => {
    setShowSubModal(false);
    setSelectedItemType('');
  };
  
  const handleFinalSelection = () => {
    setShowSubModal(false);
    setSelectedItemType('');
    onHide(); // Close ItemsModal too
  };

  const portalContainer = document.body;

  if (!portalContainer) {
    return null;
  }

  const modalContent = (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      className="items-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {categories.map((category) => {
          const categoryItems = items.filter(item => item.category === category.id);
          if (categoryItems.length === 0) return null;

          return (
            <div key={category.id} className="item-category mb-4">
              <h6 className="category-title">
                <span className="category-icon">{category.icon}</span>
                {category.name}
              </h6>
              <div className="items-grid">
                {categoryItems.map((item) => (
                  <div
                    key={item.id}
                    className="item-card"
                    onClick={() => handleItemClick(item)}
                  >
                    <div className="item-thumbnail">
                      <img src={item.thumbnail} alt={item.name} />
                    </div>
                    <div className="item-name">{item.name}</div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </Modal.Body>
    </Modal>
  );

  // Use React Portal to render modal in canvasContainer
  return (
    <>
      {ReactDOM.createPortal(modalContent, portalContainer)}
      {showSubModal && (
        <ItemSelectionViewModal
          show={showSubModal}
          onHide={handleSubModalHide}
          onFinalClose={handleFinalSelection}
          itemToSearch={selectedItemType}
          addItem={addItem}
          onAccessorySelect={onAccessorySelect}
          typeName={typeName}
          handleDoorsView={handleDoorsView}
          canvasHeight={canvasHeight}
        />
      )}
    </>
  );
};

export default ItemsModal;
